import styled from '@emotion/styled';
import { Card, Grid, Typography } from '@mui/material';
import './ppa-stage-card.scss';

const StyledTypography = styled(Typography)`
  font-size: 10px;
`;

export default function PPAStageInfoCard({
  stages
}: {
  stages: { title: string; description: string; imageUrl: string }[];
}) {
  return (
    <Card
      sx={{
        boxShadow: 6,
        height: '100%',
        padding: (theme) => theme.spacing(1)
      }}
    >
      <Grid container sx={{ height: '100%' }}>
        {stages.map((stage, index) => (
          <Grid
            key={stage.title}
            className='ppa-card-content'
            container
            item
            xs
            p={3}
            alignContent='center'
            alignItems='center'
            justifyContent='space-between'
            direction='column'
            columns={3}
          >
            {index < stages.length - 1 && stages.length > 1 ? (
              <Grid
                sx={{
                  position: 'absolute',
                  right: 0,
                  top: '30%',
                  bottom: '30%',
                  width: '1px',
                  backgroundColor: '#D9D9D9'
                }}
              />
            ) : null}
            <Grid item textAlign='center'>
              <Typography variant='text4'>{stage.title}</Typography>
            </Grid>
            <Grid item textAlign='center'>
              <StyledTypography variant='text2'>
                {stage.description}
              </StyledTypography>
            </Grid>
            <Grid item>
              <img src={stage.imageUrl} alt={stage.title} />{' '}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}
